<template>
  <div class="row">
    <div class="col-12">
      <page-header />
      <div class="row">
        <div class="col-12 main-content">
          <b-tabs
            v-model="tabIndex"
            fill
          >
            <b-tab
              v-if="tabs.includes('#devices')"
              :title="'mobile_devices' | i18n"
              @click="selectTab('#devices')"
            >
              <devices class="tab-content-container" />
            </b-tab>
            <b-tab
              v-if="tabs.includes('#users')"
              :title="'user_and_auth' | i18n"
              @click="selectTab('#users')"
            >
              <user-management class="tab-content-container" />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LicenseMixin } from '../../mixins';
import { BTabs, BTab } from 'bootstrap-vue';
import UserManagement from './user-management';
import Devices from './devices/devices';
import PageHeader from '../structure/page-header';

export default {
  name: 'Employees',
  components: { PageHeader, Devices, BTabs, BTab, UserManagement },
  mixins: [LicenseMixin],
  data: function() {
    return {
      tabIndex: 0,
      tabs: []
    };
  },
  created() {
    const tabs = ['#users'];
    if (this.license.modules.includes('RP Trade')) {
      tabs.unshift('#devices');
    }
    this.tabs = tabs;
  },
  mounted() {
    console.log(this.license,'license');
    if (this.$route.hash) {
      this.tabIndex = this.tabs.findIndex(tab => tab === this.$route.hash);
    }
    this.selectTab(this.tabs[this.tabIndex]);
  },
  methods: {
    selectTab(hash) {
      if (this.$route.hash !== hash) {
        this.$router.push({ path: this.$route.path, hash: hash });
      }
    }
  }
};
</script>

<style scoped>
.tab-content-container {
  margin-top: 5px;
}
</style>
